
import { defineComponent, onMounted, ref, watch } from 'vue'
import ClipboardJs from 'clipboard'
import { useQuasar } from 'quasar'

export default defineComponent({
  name: 'Clipable',
  props: {
    id: {
      type: [String, Number],
      default: Date.now().toString(16)
    },
    payload: {
      type: [String, Number, Array, Object],
      default: () => ('')
    },
    message: {
      type: String
    }
  },
  emits: ['clip', 'error'],
  setup (props, { emit }) {
    const $q = useQuasar()
    const clip_element = ref<Element>()
    const clipper = ref<ClipboardJs>()
    watch(() => clip_element.value, val => init())

    function init () {
      if (!clip_element.value) return
      if (clipper.value) clipper.value.destroy()

      clipper.value = new ClipboardJs(clip_element.value)

      clipper.value.on('success', e => {
        emit('clip', e)
        e.clearSelection()
        $q.notify({
          message: props.message || 'Copied to clipboard',
          position: 'top',
          classes: 'custom-notify'
        })
      })
      clipper.value.on('error', e => {
        emit('error', e)
      })
    }

    onMounted(init)

    return {
      clip_element
    }
  },
})
